(function(){
  var btn=document.getElementById('nw-fab-btn');
  var modal=document.getElementById('nw-calc-modal');
  var holder=document.getElementById('nw-cm-body');
  if(!btn||!modal||!holder){return;}
  var loaded=false, cachedHTML=null;
  function extract(html){
    var d=new DOMParser().parseFromString(html,'text/html');
    var sec=null;
    d.querySelectorAll('.shopify-section').forEach(function(s){ if(/kalkylator/i.test(s.id||'')||s.querySelector('[id*="kalkylator"],[class*="kalkylator"]')){ sec=s; } });
    if(!sec){ sec=d.querySelector('[id*="kalkylator"],[class*="kalkylator"]'); }
    return sec?sec.innerHTML:null;
  }
  function runScripts(c){
    c.querySelectorAll('script').forEach(function(old){
      var s=document.createElement('script');
      for(var i=0;i<old.attributes.length;i++){ s.setAttribute(old.attributes[i].name,old.attributes[i].value); }
      if(!old.src){ s.textContent=old.textContent; }
      old.parentNode.replaceChild(s,old);
    });
  }
  function inject(html){ holder.innerHTML=html; runScripts(holder); }
  function fallback(){ holder.innerHTML='<div class="nw-cm-loading">Kunde inte ladda kalkylatorn. <a href="/pages/kalkylatorn">Öppna kalkylatorn</a></div>'; }
  function prefetch(){
    fetch('/pages/kalkylatorn',{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){ cachedHTML=extract(html); }).catch(function(){});
  }
  if('requestIdleCallback' in window){ requestIdleCallback(prefetch,{timeout:4000}); } else { setTimeout(prefetch,2500); }
  function openModal(){
    if(!loaded){
      if(cachedHTML){ inject(cachedHTML); }
      else { fetch('/pages/kalkylatorn',{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){ var h=extract(html); if(h){inject(h);}else{fallback();} }).catch(fallback); }
      loaded=true;
    }
    modal.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
  }
  function closeModal(){ modal.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }
  btn.addEventListener('click',openModal);
  modal.addEventListener('click',function(e){ if(e.target.hasAttribute('data-close')){closeModal();} });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&modal.getAttribute('aria-hidden')==='false'){closeModal();} });

  function esc(s){ return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  var printBtn=document.getElementById('nw-calc-print');
  if(printBtn){
    printBtn.addEventListener('click',function(){
      // Build clean rows from the calculator's summary (skip empty/placeholder rows)
      var rowsHtml='';
      var rows=[].slice.call(holder.querySelectorAll('.sumRow'));
      rows.forEach(function(r){
        var k=r.children[0]?r.children[0].textContent.trim():'';
        var v=r.children[1]?r.children[1].textContent.trim():'';
        if(!k||!v||v==='—'||v==='-'||v.indexOf('→')>-1){ return; }
        var isSum=/summa/i.test(k);
        rowsHtml+='<div class="r'+(isSum?' sum':'')+'"><span>'+esc(k)+'</span><span>'+esc(v)+'</span></div>';
      });
      if(!rowsHtml){ rowsHtml='<div class="r"><span>Fyll i kalkylatorn för att se din beräkning.</span><span></span></div>'; }
      // Logo from the site header
      var logoEl=document.querySelector('.header__heading-logo');
      var logoSrc=logoEl?(logoEl.currentSrc||logoEl.src||''):'';
      var head=logoSrc?'<img class="logo" src="'+logoSrc+'" alt="Nobile Wood">':'<div class="brand">NOBILE WOOD</div>';
      var dt=new Date().toLocaleDateString('sv-SE');
      var css='body{font-family:\'Helvetica Neue\',Helvetica,Arial,sans-serif;color:#1d1d1f;margin:0;padding:44px 32px;background:#fff;-webkit-print-color-adjust:exact;print-color-adjust:exact}'
        +'.wrap{max-width:560px;margin:0 auto}'
        +'.logo{display:block;height:46px;width:auto;margin:0 auto 16px}'
        +'.brand{text-align:center;font-size:14px;letter-spacing:.3em;font-weight:700;margin-bottom:16px}'
        +'.eyebrow{text-align:center;font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#9a9a9a;margin:0 0 6px}'
        +'h1{text-align:center;font-size:24px;font-weight:600;margin:0 0 4px}'
        +'.date{text-align:center;color:#9a9a9a;font-size:13px;margin:0 0 26px}'
        +'.card{border:1px solid #e7e7e7;border-radius:16px;padding:18px 22px}'
        +'.r{display:flex;justify-content:space-between;align-items:baseline;gap:16px;padding:9px 0;border-bottom:1px solid #f1f1f1;font-size:15px}'
        +'.r:last-child{border-bottom:none}'
        +'.r span:first-child{color:#666}'
        +'.r span:last-child{font-weight:600;text-align:right;white-space:nowrap}'
        +'.r.sum{margin-top:8px;border-top:2px solid #1d1d1f;border-bottom:none;padding-top:14px;font-size:19px}'
        +'.r.sum span:first-child{color:#1d1d1f;font-weight:600}'
        +'.ft{margin-top:24px;font-size:12px;color:#8a8a8a;line-height:1.7;text-align:center}'
        +'.pbtn{display:block;width:100%;margin-top:24px;background:#1d1d1f;color:#fff;border:none;border-radius:980px;padding:13px;font-size:13px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}'
        +'@media print{.pbtn{display:none}}';
      var docHtml='<!doctype html><html lang="sv"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Din golvkalkyl</title><style>'+css+'</style></head><body><div class="wrap">'
        +head
        +'<div class="eyebrow">Golvkalkyl</div>'
        +'<h1>Din golvkalkyl</h1>'
        +'<div class="date">'+dt+'</div>'
        +'<div class="card">'+rowsHtml+'</div>'
        +'<div class="ft">Priser inkl. spill. Fri frakt i Stockholm &middot; Leverans 10&ndash;14 arbetsdagar.<br>Fr&aring;gor eller redo att best&auml;lla?<br>info@nobilewood.com &middot; 073-985 84 46 &middot; nobilewood.com</div>'
        +'<button class="pbtn" type="button" onclick="window.print()">Skriv ut / spara som PDF</button>'
        +'</div></body></html>';
      var w=window.open('','_blank');
      if(!w){ return; }
      w.document.open(); w.document.write(docHtml); w.document.close(); w.focus();
      setTimeout(function(){ try{ w.print(); }catch(e){} }, 700);
    });
  }
})();
